


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Form, FormItem, Input } from 'element-ui';
import { StakeHolderDetails } from '@/types/types';
import {
  ShipmentFields,
  ShipmentUpdateInput,
  PartyDetailsFields,
  PartyDetailsInput
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class PartyDetails extends Vue {
  @Prop() public shipment!: ShipmentFields;
  @Prop({ default: 'shipperDetails' }) public partyType!: string;
  @Prop() public party!: PartyDetailsFields;

  private name = 'party-details';
  private editMode = false;
  private partyInput: PartyDetailsInput = {
    name: null,
    fullAddress: null,
    phoneNumber: null,
    faxNumber: null,
    email: null
  };

  private toggleEdit() {
    this.setPartyInput(this.party);
    this.editMode = !this.editMode;
  }

  // restor prop values
  private cancel() {
    this.toggleEdit();
  }

  private submit() {
    this.$store.dispatch(
      'Shipment/updateShipment',
      { id: this.shipment.id, [this.partyType]: { ...this.partyInput } }
    );
    this.toggleEdit();
  }

  private setPartyInput(party: PartyDetailsFields) {
    this.partyInput = { ...party };
  }
}
